import style from "./Loader.module.scss";
import {Heading} from "../../ui-components/heading.tsx";

export const LoaderComponent = () => {

    return(
        <div className={style.Wrapper}>
            <Heading level={2} className={"text-[22px] text-white font-extrabold font-sarabun mb-8"}>Tex.media</Heading>
            <div className={style.BlinkingDots}>
                {[...Array(9)].map((_, i) => (
                    <span
                        key={i}
                        className={style.Dot}
                        style={{'--i': i} as React.CSSProperties}
                    />
                ))}
            </div>
        </div>
    )
}